import React from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "./secciones/notFound/NotFound";
import Proceso from "./secciones/proceso/Proceso";

class Router extends React.Component {
  render() {
    return (
      <Routes>
        <Route path="/:numeroProceso" element={<Proceso />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }
}

export default Router;
